export const PEOPLE_ENTITY_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
export const PEOPLE_ENTITY_MANIFEST_KEY = 'user-profile-preview';
